export const DEFAULT_SHORTCUTS = [
  {
    href: '/machines/categories',
    titleKey: 'aboutPage.shortcuts.items.0.title',
    descriptionKey: 'aboutPage.shortcuts.items.0.description',
    image: '/shortcuts/1.webp',
  },
  {
    href: '/spare-parts',
    titleKey: 'aboutPage.shortcuts.items.1.title',
    descriptionKey: 'aboutPage.shortcuts.items.1.description',
    image: '/shortcuts/2.webp',
  },
  {
    href: '/contact',
    titleKey: 'aboutPage.shortcuts.items.2.title',
    descriptionKey: 'aboutPage.shortcuts.items.2.description',
    image: '/shortcuts/3.webp',
  },
  {
    href: '/services',
    titleKey: 'aboutPage.shortcuts.items.3.title',
    descriptionKey: 'aboutPage.shortcuts.items.3.description',
    image: '/shortcuts/4.webp',
  },
];
